import React, { Component } from 'react';
import Modal from 'react-responsive-modal';
import { PulseLoader } from 'react-spinners';
import { compose, graphql } from 'react-apollo';
import { withAlert } from 'react-alert';
import { deleteCategory, categories } from '../../../../../../queries';

import { Content, Button } from './styles';

class ConfirmCategoryModal extends Component {
  state = {
    loading: false,
    categoryId: '',
  }

  openConfirmCategoryModal = (categoryId) => {
    this.setState({ categoryId });
  }

  handleSubmit = async () => {
    this.setState({ loading: true });

    this.props
      .deleteCategory({
        variables: {
          storeId: this.props.storeId,
          categoryId: this.state.categoryId,
        },
        refetchQueries: [{
          query: categories,
          variables: { storeId: this.props.storeId },
        }],
      })
      .then(async (res) => {
        this.setState({ loading: false });

        this.props.close();
        this.props.closeEditCategoryModal();
        this.props.handleCategoriesList(res.data.deleteCategoryPortal);
        this.props.alert.success('Categoria excluída com sucesso');
      });
  }

  render() {
    const { open, close } = this.props;

    return (
      <Modal
        open={open}
        onClose={close}
        center
        ref={(ref) => { this.confirmRoleFormModal = ref; }}
      >
        <Content>
          <h2>Excluir categoria</h2>
          <p className="subtitle">
            {'Se a categoria for excluída os materiais dela também serão, deseja continuar mesmo assim?'}
          </p>
          <Button type="submit" disabled={this.state.loading} onClick={this.handleSubmit}>
            {!this.state.loading ? (
              'Continuar'
            ) : (
              <PulseLoader
                sizeUnit="px"
                size={7}
                color="#FFFFFF"
                loading={this.state.loading}
              />
            )}
          </Button>
        </Content>
      </Modal>
    );
  }
}

export default compose(
  withAlert(),
  graphql(deleteCategory, { name: 'deleteCategory', withRef: true }),
)(ConfirmCategoryModal);
